// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"d1972f9a","796":"caf92bf6"}[chunkId] + ".chunk.js";
};